import { useSelector } from 'react-redux'

import AdminChecklist from '../../../../components/ReusableComponents/AdminChecklist/index'
import { ReactComponent as WarningIcon } from '../warning-icon.svg'
import styles from './AdminHelper.module.scss'

export const AdminHelper = ({ subsidiary, pos, showTooltip, subsidiaryId }) => {
  const pmsSyncStatuses = useSelector(s => s.pmsSyncStatus.list)

  const statusOfCurrentSubsidiary = pmsSyncStatuses?.find(
    s => s.subsidiaryId === subsidiaryId
  )

  const needsAttention = !(
    subsidiary.hasBillingContact &&
    subsidiary.hasTripAdvisorLink &&
    statusOfCurrentSubsidiary?.isAllReportsHealthy
  )

  return (
    <>
      {needsAttention && <WarningIcon className={styles.warningIcon} />}
      {showTooltip && needsAttention && (
        <AdminChecklist
          x={pos.left - 214}
          y={pos.top - 54}
          list={[
            {
              name: 'Billing contact',
              checked: subsidiary.hasBillingContact
            },
            {
              name: 'TripAdvisor Link',
              checked: subsidiary.hasTripAdvisorLink
            },
            {
              name: 'PMS SYNC',
              checked: statusOfCurrentSubsidiary?.isAllReportsHealthy
            }
          ]}
        />
      )}
    </>
  )
}
